import React from 'react';

export const StatusBadge = ({ text, textColor, borderColor }: StatusBadgeProps) => {
  return (
    <div className={'flex'}>
      <div className={`border rounded-full py-1 px-3 text-sm`} style={{
        color: textColor,
        borderColor: borderColor,
      }}>
        <span>{text}</span>
      </div>
    </div>
  );
};

interface StatusBadgeProps {
  text: string;
  textColor: string;
  borderColor: string;
}